module.exports = __webpack_public_path__ + "static/media/Banner2.93817019.jpg";